import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {MenuTestPage} from '../pages/MenuTestPage'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'

import {GroupSMS} from '../modules/SMSBroadCast/GroupSMS'
import {ContactFileSMS} from '../modules/SMSBroadCast/ContactFileSMS'
import {SmartSMS} from '../modules/SMSBroadCast/SmartSMS'
import {QuickSMS} from '../modules/SMSBroadCast/QuickSMS'
import CreateUser from '../modules/Users/CreateUser'
import Price from '../modules/PriceList/Price'
import TodayBroadCast from '../modules/LiveReports/TodayBroadCast'
import TodaySMS from '../modules/LiveReports/TodaySMS'
import SummeryLogs from '../modules/LiveReports/SummeryLogs'
import MNOBalanceNotifyList from '../modules/Monitoring/MNOBalanceNotifyList'
import BalanceNotificationLog from '../modules/Monitoring/BalanceNotificationLog'
import BalanceThreshold from '../modules/Monitoring/BalanceThreshold'
import LogoUpload from '../modules/Settings/LogoUpdates'
import BroadCastHistory from '../modules/Archive/BroadCastHistory'
import SMSHistory from '../modules/Archive/SMSHistory'
import RechargeFrom from '../modules/Billing/TransactionReports/RechargeFrom'
import RechargeTo from '../modules/Billing/TransactionReports/RechargeTo'
import InvoiceCreate from '../modules/Billing/Invoice/InvoiceCreate'
import InvoiceList from '../modules/Billing/Invoice/InvoiceList'
import Send from '../modules/Schedules/Send'
import Pending from '../modules/Schedules/Pending'
import ChangePassword from '../modules/DeveloperOptions/ChangePassword'
import OpwiseReport from '../modules/SummeryReport/OpwiseReport'
import SenderwiseReport from '../modules/SummeryReport/SenderwiseReport'
import OPandSenderwiseReport from '../modules/SummeryReport/OPandSenderwiseReport'
import {SMSCampaign} from '../modules/SMSBroadCast/SMSCampaign'
import SpamFilter from '../modules/SpamFilter/SpamFilter'
import {RoleBasedRoute} from './RoleBasedRoute'
import RetrySmsList from '../modules/LiveReports/RetrySmsList'
import {UpdateSenderId} from '../modules/Users/UpdateSenderId'
import Cancel from '../modules/Schedules/Cancel'
import PriceUpdate from '../modules/PriceList/PriceUpdate'
import ApiKey from '../modules/DeveloperOptions/ApiKey'
import Documentation from '../modules/DeveloperOptions/Documentation'
import KycForm from '../modules/Users/KycForm'
import UserDetails from '../modules/Users/UserDetails'
import Payment from '../modules/PaymentRequest/Payment'
import SenderIdWrapper from '../modules/SMSBroadCast/Sender/SenderIdWrapper'
import SMSTemplateWrapper from '../modules/SMSBroadCast/SMSTemplate/SMSTemplateWrapper'
import SpamFiltrerWrapper from '../modules/SpamFilter/SpamFiltrerWrapper'
import UserListWrapper from '../modules/Users/UserListWrapper'
import DeliveryLogReport from '../modules/Archive/DeliveryLogReport'
import SettingWrapper from '../modules/Settings/SettingWrapper'
import TicketOverview from '../modules/Ticket/TicketOverview'
import TIcketsListWrapper from '../modules/Ticket/TIcketList/TicketsListWrapper'
import Department from '../modules/Ticket/Department'
import ArticleWrapper from '../modules/KnowledgeBase/Article/ArticleWrapper'
import CategoryWrapper from '../modules/KnowledgeBase/Category/CategoryWrapper'
import KnowledgeBaseOverview from '../modules/KnowledgeBase/KnowledgeBaseOverview'
import Notifications from '../modules/notifications/Notifications'
import RoutesConfig from '../modules/routes/RoutesConfig'
import RouteManagement from '../modules/route-mangement/RouteManagement'
import DLRManagement from '../modules/dlr-management/DLRManagement'
import TicketQueryDetails from '../modules/Ticket/TIcketList/TicketQueryDetails'
import ArticlesByCategory from '../modules/KnowledgeBase/Article/ArticlesByCategory'
import ArticleDetails from '../modules/KnowledgeBase/Article/ArticleDetails'
import ArticleForm from '../modules/KnowledgeBase/Article/ArticleForm'
import RouteSenderDetails from '../modules/route-mangement/RouteSenderDetails'
import UserRole from '../modules/Users/user-role/UserRole'
import RoleManagement from '../modules/Users/role-management/RoleManagement'
import MenuManagement from '../modules/menu-management/MenuManagement'
import InvoiceView from '../modules/Billing/Invoice/InvoiceView'
import PreviewInvoice from '../modules/Billing/Invoice/PreviewInvoice'
import Voucher from '../modules/Billing/Voucher/Voucher'
import VoucherPreview from '../modules/Billing/Voucher/VoucherPreview'
import CustomerLedger from '../modules/customer-ledger/CustomerLedger'

const ContactAndGroup = lazy(() => import('../modules/ContactAndGroup/ContactAndGroup'))

const PrivateRoutes = () => {
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'))
  const Analyze = lazy(() => import('../modules/analyze/Analyze'))
  const People = lazy(() => import('../modules/people/People'))
  const RittProfile = lazy(() => import('../modules/ritt-settings/ritt-profile/RittProfile'))
  const AccountSetting = lazy(
    () => import('../modules/ritt-settings/account-settings/AccountSettings')
  )
  const SmscAssign = lazy(() => import('../modules/Users/smsc-assign/SmscAssign'))
  const VoiceBroadcast = lazy(() => import('../modules/voice-broadcast/VoiceBroadcast'))
  const CallerIds = lazy(() => import('../modules/caller-ids/components/CallerIds'))
  const ContactGroup = lazy(
    () => import('../modules/voice-contacts/contact-group/components/ContactGroup')
  )
  const ContactList = lazy(
    () => import('../modules/voice-contacts/contact-list/components/ContactList')
  )
  const BillingLogs = lazy(() => import('../modules/Billing/logs/component/BillingLogs'))
  const UserManagementPage = lazy(
    () => import('../modules/voice-user/components/UserManagementPage')
  )

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/analyze/dashboard' />} />
        {/* Pages */}
        <Route path='dashboard' element={<DashboardWrapper />} />
        <Route path='builder' element={<BuilderPageWrapper />} />
        <Route path='menu-test' element={<MenuTestPage />} />
        {/* Lazy Modules */}

        {/* Start RITT */}
        <Route
          path='analyze/*'
          element={
            <SuspensedView>
              <Analyze />
            </SuspensedView>
          }
        />

        <Route
          path='user/*'
          element={
            <SuspensedView>
              <UserManagementPage />
            </SuspensedView>
          }
        />

        <Route
          path='routes/*'
          element={
            <SuspensedView>
              <RoutesConfig />
            </SuspensedView>
          }
        />

        <Route
          path='route-management/*'
          element={
            <SuspensedView>
              <RouteManagement />
            </SuspensedView>
          }
        />

        <Route
          path='route-management/:roleName/:id'
          element={
            <SuspensedView>
              {/* <RoleDetails /> */}
              <RouteSenderDetails />
            </SuspensedView>
          }
        />

        <Route
          path='people/*'
          element={
            <SuspensedView>
              <People />
            </SuspensedView>
          }
        />

        <Route
          path='notifications/*'
          element={
            <SuspensedView>
              <Notifications />
            </SuspensedView>
          }
        />

        <Route
          path='profile/*'
          element={
            <SuspensedView>
              <RittProfile />
            </SuspensedView>
          }
        />

        <Route
          path='account-settings/*'
          element={
            <SuspensedView>
              <AccountSetting />
            </SuspensedView>
          }
        />

        <Route
          path='dlr-management/*'
          element={
            <SuspensedView>
              <DLRManagement />
            </SuspensedView>
          }
        />
        {/* End RITT */}

        <Route
          path='ticket/view/:id'
          element={
            <SuspensedView>
              <TicketQueryDetails />
            </SuspensedView>
          }
        />

        <Route
          path='pages/profile/*'
          element={
            <SuspensedView>
              <ProfilePage />
            </SuspensedView>
          }
        />
        <Route
          path='pages/wizards/*'
          element={
            <SuspensedView>
              <WizardsPage />
            </SuspensedView>
          }
        />
        <Route
          path='widgets/*'
          element={
            <SuspensedView>
              <WidgetsPage />
            </SuspensedView>
          }
        />
        <Route
          path='account/*'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />
        <Route
          path='smsbroadcast/quicksms'
          element={
            <SuspensedView>
              <QuickSMS />
            </SuspensedView>
          }
        ></Route>

        <Route
          path='smsbroadcast/groupsms/*'
          element={
            <SuspensedView>
              <GroupSMS />
            </SuspensedView>
          }
        ></Route>

        <Route
          path='smsbroadcast/contactfilesms/*'
          element={
            <SuspensedView>
              <ContactFileSMS />
            </SuspensedView>
          }
        ></Route>

        <Route
          path='smsbroadcast/senderid/*'
          element={
            <SuspensedView>
              <SenderIdWrapper />
            </SuspensedView>
          }
        ></Route>

        <Route
          path='smsbroadcast/smscampaign/*'
          element={
            <SuspensedView>
              <SMSCampaign />
            </SuspensedView>
          }
        ></Route>

        <Route
          path='smsbroadcast/smartsms/*'
          element={
            <SuspensedView>
              <SmartSMS />
            </SuspensedView>
          }
        ></Route>

        <Route
          path='smsbroadcast/smstemplete/*'
          element={
            <SuspensedView>
              <SMSTemplateWrapper />
            </SuspensedView>
          }
        ></Route>

        <Route
          path='contactAndgroup/*'
          element={
            <SuspensedView>
              <ContactAndGroup />
            </SuspensedView>
          }
        ></Route>

        <Route
          path='contacts/contact-group'
          element={
            <SuspensedView>
              <ContactGroup />
            </SuspensedView>
          }
        ></Route>

        <Route
          path='contacts/contact-list/:groupId?'
          element={
            <SuspensedView>
              <ContactList />
            </SuspensedView>
          }
        ></Route>

        {/* <Route
          path='smsfiltertext/*'
          element={
            <SuspensedView>
              <SmsFilterText />
            </SuspensedView>
          }
        ></Route> */}

        <Route element={<RoleBasedRoute allowedRoles={[1, 2]} />}>
          <Route
            path='spam-filter/*'
            element={
              <SuspensedView>
                <SpamFiltrerWrapper />
              </SuspensedView>
            }
          />
        </Route>

        <Route
          path='paymentrequest/*'
          element={
            <SuspensedView>
              <Payment />
            </SuspensedView>
          }
        ></Route>

        <Route element={<RoleBasedRoute allowedRoles={[1, 2]} />}>
          <Route
            path='users/list/*'
            element={
              <SuspensedView>
                <UserListWrapper />
              </SuspensedView>
            }
          />
        </Route>

        {/* <Route element={<RoleBasedRoute allowedRoles={[1, 2]} />}>
          <Route
            path='users/:useraction/*'
            element={
              <SuspensedView>
                <CloneUser />
              </SuspensedView>
            }
          />
        </Route> */}

        <Route element={<RoleBasedRoute allowedRoles={[1, 2]} />}>
          <Route
            path='users/:useraction/*'
            element={
              <SuspensedView>
                <CreateUser />
              </SuspensedView>
            }
          />
        </Route>

        <Route
          path='users/role/*'
          element={
            <SuspensedView>
              <UserRole />
            </SuspensedView>
          }
        ></Route>

        <Route
          path='users/roles-management/*'
          element={
            <SuspensedView>
              <RoleManagement />
            </SuspensedView>
          }
        ></Route>

        <Route
          path='menu-management/*'
          element={
            <SuspensedView>
              <MenuManagement />
            </SuspensedView>
          }
        ></Route>

        <Route
          path='users/smsc-assign/*'
          element={
            <SuspensedView>
              <SmscAssign />
            </SuspensedView>
          }
        ></Route>

        <Route element={<RoleBasedRoute allowedRoles={[1, 2]} />}>
          <Route
            path='users/kycForm/:id'
            element={
              <SuspensedView>
                <KycForm />
              </SuspensedView>
            }
          />
        </Route>

        <Route element={<RoleBasedRoute allowedRoles={[1, 2]} />}>
          <Route
            path='users/updatesenderid/:id/*'
            element={
              <SuspensedView>
                <UpdateSenderId />
              </SuspensedView>
            }
          />
        </Route>

        <Route element={<RoleBasedRoute allowedRoles={[1, 2]} />}>
          <Route
            path='users/userdetails/:id/*'
            element={
              <SuspensedView>
                <UserDetails />
              </SuspensedView>
            }
          />
        </Route>

        <Route
          path='livereports/todaybroadcast/*'
          element={
            <SuspensedView>
              <TodayBroadCast />
            </SuspensedView>
          }
        ></Route>

        <Route
          path='livereports/todaysms/*'
          element={
            <SuspensedView>
              <TodaySMS />
            </SuspensedView>
          }
        ></Route>

        {/* <Route path='livereports/smstodayapi/*'
          element={
            <SuspensedView>
              <SMSTodayAPI />
            </SuspensedView>
          }>         
        </Route> */}

        {/* <Route
          path='livereports/smstodayapireportdownload/*'
          element={
            <SuspensedView>
              <SMSTodayAPIReportDownload />
            </SuspensedView>
          }>         
        </Route> */}

        <Route
          path='livereports/summerylogs/*'
          element={
            <SuspensedView>
              <SummeryLogs />
            </SuspensedView>
          }
        ></Route>

        <Route
          path='livereports/retrysmslist/*'
          element={
            <SuspensedView>
              <RetrySmsList />
            </SuspensedView>
          }
        ></Route>

        <Route
          path='pricelist/price/*'
          element={
            <SuspensedView>
              <Price />
            </SuspensedView>
          }
        ></Route>

        <Route
          path='users/list/price-update/:id'
          element={
            <SuspensedView>
              <PriceUpdate />
            </SuspensedView>
          }
        ></Route>

        <Route
          path='archive/broadcasthistory/*'
          element={
            <SuspensedView>
              <BroadCastHistory />
            </SuspensedView>
          }
        ></Route>

        <Route
          path='archive/smshistory/*'
          element={
            <SuspensedView>
              <SMSHistory />
            </SuspensedView>
          }
        ></Route>

        {/* <Route path='archive/smshistoryapi/*'
          element={
            <SuspensedView>
              <SMSHistoryAPI />
            </SuspensedView>
          }>         
        </Route> */}

        <Route
          path='archive/archivedeliverylogreport/*'
          element={
            <SuspensedView>
              <DeliveryLogReport />
            </SuspensedView>
          }
        ></Route>

        {/* <Route path='archive/apireportdownload/*'
          element={
            <SuspensedView>
              <APIReportDownload />
            </SuspensedView>
          }>         
        </Route> */}
        {/* 
        <Route path='archive/panelreportdownload/*'
          element={
            <SuspensedView>
              <PanelReportDownload/>
            </SuspensedView>
          }>         
        </Route> */}

        <Route element={<RoleBasedRoute allowedRoles={[1, 2, 3]} />}>
          <Route
            path='Billing/TransactionReports/rechargefrom/*'
            element={
              <SuspensedView>
                <RechargeFrom />
              </SuspensedView>
            }
          />
        </Route>

        <Route element={<RoleBasedRoute allowedRoles={[1, 2]} />}>
          <Route
            path='Billing/TransactionReports/rechargeto/*'
            element={
              <SuspensedView>
                <RechargeTo />
              </SuspensedView>
            }
          />
        </Route>

        <Route element={<RoleBasedRoute allowedRoles={[1, 2]} />}>
          <Route
            path='Billing/Invoice/create/*'
            element={
              <SuspensedView>
                <InvoiceCreate />
              </SuspensedView>
            }
          />
        </Route>

        <Route element={<RoleBasedRoute allowedRoles={[1, 2, 3]} />}>
          <Route
            path='Billing/Invoice/list/*'
            element={
              <SuspensedView>
                <InvoiceList />
              </SuspensedView>
            }
          />
        </Route>

        <Route element={<RoleBasedRoute allowedRoles={[1, 2, 3]} />}>
          <Route
            path='Billing/Invoice/:id/*'
            element={
              <SuspensedView>
                <InvoiceView />
              </SuspensedView>
            }
          />
        </Route>

        <Route element={<RoleBasedRoute allowedRoles={[1, 2, 3]} />}>
          <Route
            path='Billing/Invoice/preview/*'
            element={
              <SuspensedView>
                <PreviewInvoice />
              </SuspensedView>
            }
          />
        </Route>

        <Route element={<RoleBasedRoute allowedRoles={[1, 2, 3]} />}>
          <Route
            path='Billing/voucher/*'
            element={
              <SuspensedView>
                <Voucher />
              </SuspensedView>
            }
          />
        </Route>

        <Route element={<RoleBasedRoute allowedRoles={[1, 2, 3]} />}>
          <Route
            path='Billing/voucher/preview/:id/*'
            element={
              <SuspensedView>
                <VoucherPreview />
              </SuspensedView>
            }
          />
        </Route>

        <Route
          path='billing/logs/*'
          element={
            <SuspensedView>
              <BillingLogs />
            </SuspensedView>
          }
        />

        <Route element={<RoleBasedRoute allowedRoles={[1, 2, 3]} />}>
          <Route
            path='customer-ledger/*'
            element={
              <SuspensedView>
                <CustomerLedger />
              </SuspensedView>
            }
          />
        </Route>

        {/* <Route
          path='Billing/TransactionReports/rechargefrom/*'
          element={
            <SuspensedView>
              <RechargeFrom />
            </SuspensedView>
          }
        ></Route> */}

        {/* <Route
          path='Billing/TransactionReports/rechargeto/*'
          element={
            <SuspensedView>
              <RechargeTo />
            </SuspensedView>
          }
        ></Route> */}

        {/* <Route
          path='Billing/Invoice/invoicecreate/*'
          element={
            <SuspensedView>
              <InvoiceCreate />
            </SuspensedView>
          }
        ></Route> */}

        {/* <Route
          path='Billing/Invoice/invoicelist/*'
          element={
            <SuspensedView>
              <InvoiceList />
            </SuspensedView>
          }
        ></Route> */}

        <Route
          path='Schedules/send/*'
          element={
            <SuspensedView>
              <Send />
            </SuspensedView>
          }
        ></Route>

        <Route
          path='Schedules/pending/*'
          element={
            <SuspensedView>
              <Pending />
            </SuspensedView>
          }
        ></Route>

        <Route
          path='Schedules/cancel/*'
          element={
            <SuspensedView>
              <Cancel />
            </SuspensedView>
          }
        ></Route>

        <Route
          path='SummeryReport/opwisereport/*'
          element={
            <SuspensedView>
              <OpwiseReport />
            </SuspensedView>
          }
        ></Route>

        <Route
          path='SummeryReport/senderwisereport/*'
          element={
            <SuspensedView>
              <SenderwiseReport />
            </SuspensedView>
          }
        ></Route>

        <Route
          path='SummeryReport/opandSenderwisereport/*'
          element={
            <SuspensedView>
              <OPandSenderwiseReport />
            </SuspensedView>
          }
        ></Route>

        <Route
          path='DeveloperOptions/changepassword/*'
          element={
            <SuspensedView>
              <ChangePassword />
            </SuspensedView>
          }
        ></Route>

        <Route
          path='DeveloperOptions/apikey/*'
          element={
            <SuspensedView>
              <ApiKey />
            </SuspensedView>
          }
        ></Route>

        <Route
          path='DeveloperOptions/documentation/*'
          element={
            <SuspensedView>
              <Documentation />
            </SuspensedView>
          }
        ></Route>

        {/* Ticket Start */}
        <Route
          path='tickets/overview/*'
          element={
            <SuspensedView>
              <TicketOverview />
            </SuspensedView>
          }
        ></Route>

        <Route
          path='tickets/list/*'
          element={
            <SuspensedView>
              <TIcketsListWrapper />
            </SuspensedView>
          }
        ></Route>

        <Route
          path='tickets/department/*'
          element={
            <SuspensedView>
              <Department />
            </SuspensedView>
          }
        ></Route>
        {/* Ticket End */}

        {/* Knowledge Base Start */}
        <Route
          path='knowledgebase/overview/*'
          element={
            <SuspensedView>
              <KnowledgeBaseOverview />
            </SuspensedView>
          }
        ></Route>

        <Route
          path='knowledgebase/article/*'
          element={
            <SuspensedView>
              <ArticleWrapper />
            </SuspensedView>
          }
        ></Route>

        <Route
          path='knowledgebase/article/:type'
          element={
            <SuspensedView>
              <ArticleForm />
            </SuspensedView>
          }
        ></Route>

        <Route
          path='knowledgebase/category/*'
          element={
            <SuspensedView>
              <CategoryWrapper />
            </SuspensedView>
          }
        ></Route>

        <Route
          path='knowledgebase/articles-by-category/:id'
          element={
            <SuspensedView>
              <ArticlesByCategory />
            </SuspensedView>
          }
        ></Route>

        <Route
          path='knowledgebase/article-view/:id'
          element={
            <SuspensedView>
              <ArticleDetails />
            </SuspensedView>
          }
        ></Route>
        {/* Knowledge Base End */}

        <Route
          path='settings/*'
          element={
            <SuspensedView>
              <SettingWrapper />
            </SuspensedView>
          }
        ></Route>

        {/* Start Voice Routes */}

        {/* Caller Ids */}
        <Route
          path='caller-ids/*'
          element={
            <SuspensedView>
              <CallerIds />
            </SuspensedView>
          }
        />

        {/* Contact Group */}
        <Route
          path='contact-group'
          element={
            <SuspensedView>
              <ContactGroup />
            </SuspensedView>
          }
        />

        {/* Contact List */}
        <Route
          path='contact-list'
          element={
            <SuspensedView>
              <ContactList />
            </SuspensedView>
          }
        />

        {/* Voice Broadcast */}
        <Route
          path='voice-broadcast/*'
          element={
            <SuspensedView>
              <VoiceBroadcast />
            </SuspensedView>
          }
        />

        {/* End Voice Routes */}
      </Route>
      {/* End Master Layout */}

      <Route
        path='Monitoring/mnobalancenotifylist/*'
        element={
          <SuspensedView>
            <MNOBalanceNotifyList />
          </SuspensedView>
        }
      ></Route>

      <Route
        path='Monitoring/balancethreshold/*'
        element={
          <SuspensedView>
            <BalanceThreshold />
          </SuspensedView>
        }
      ></Route>

      <Route
        path='Monitoring/balancenotificationlog/*'
        element={
          <SuspensedView>
            <BalanceNotificationLog />
          </SuspensedView>
        }
      ></Route>

      <Route element={<RoleBasedRoute allowedRoles={[1]} />}>
        <Route
          path='Settings/logoupdates/*'
          element={
            <SuspensedView>
              <LogoUpload />
            </SuspensedView>
          }
        ></Route>

        <Route
          path='spamFilter/*'
          element={
            <SuspensedView>
              <SpamFilter />
            </SuspensedView>
          }
        ></Route>

        <Route
          path='apps/chat/*'
          element={
            <SuspensedView>
              <ChatPage />
            </SuspensedView>
          }
        />

        <Route
          path='apps/user-management/*'
          element={
            <SuspensedView>
              <UsersPage />
            </SuspensedView>
          }
        />
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

export const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
